<template>
  <div class="container-fluid ServiceSection">
    <div class="row">
      <div
        class="col-md-4 col-lg-4 col-sm-12 FadeRight"
        data-aos="fade-right"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        style="padding: 40px"
      >
        <div class="row">
          <div class="moto-widget-text-content moto-widget-text-editable">
            <p class="moto-text_system_13 animate1" style="text-align: center">
              <span
                class="display-9 my-3 font-weight-bold moto-color1_3 animate1"
                >01</span
              >
            </p>
            <div class="dez-separator bg-primary"></div>
            <h3 class="moto-text_system_12" style="text-align: center">
              <span class="moto-color5_5 display-8 my-3 font-weight-bold"
                >DOOR TO DOOR<br />SERVICE</span
              >
            </h3>
            <!-- <p class="moto-text_normal" style="text-align: center;">&nbsp;</p> -->
            <p class="moto-text_normal my-3" style="text-align: center">
              <span class="moto-color5_5"
                >Offering door-to-door<br />service with drop-off right<br />at
                your next destination.</span
              >
            </p>
          </div>
        </div>
      </div>

      <div
        class="col-md-4 col-lg-4 col-sm-12 FadeDown"
        data-aos="fade-down"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        style="padding: 40px"
      >
        <div class="row">
          <div class="moto-widget-text-content moto-widget-text-editable">
            <p class="moto-text_system_13 animate2" style="text-align: center">
              <span
                class="display-9 my-3 font-weight-bold moto-color1_3 animate2"
                >02</span
              >
            </p>
            <div class="dez-separator bg-primary"></div>
            <h3 class="moto-text_system_12" style="text-align: center">
              <span class="moto-color5_5 display-8 my-3 font-weight-bold"
                >PARCEL<br />DELIVERY</span
              >
            </h3>
            <!-- <p class="moto-text_normal" style="text-align: center;">&nbsp;</p> -->
            <p class="moto-text_normal my-3" style="text-align: center">
              <span class="moto-color5_5"
                >With more than 4000 taxi <br />cabs in its network, TaxiVIP can
                <br />deliver your parcel to its destination.</span
              >
            </p>
          </div>
        </div>
      </div>
      <div
        class="col-md-4 col-lg-4 col-sm-12 FadeLeft"
        data-aos="fade-left"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-mirror="true"
        data-aos-once="false"
        style="padding: 40px"
      >
        <div class="row">
          <div class="moto-widget-text-content moto-widget-text-editable">
            <p class="moto-text_system_13 animate3" style="text-align: center">
              <span
                class="display-9 my-3 font-weight-bold moto-color1_3 animate3"
                >03</span
              >
            </p>
            <div class="dez-separator bg-primary"></div>
            <h3 class="moto-text_system_12" style="text-align: center">
              <span class="moto-color5_5 display-8 my-3 font-weight-bold"
                >AIRPORT<br />TRANSFER</span
              >
            </h3>
            <!-- <p class="moto-text_normal" style="text-align: center;">&nbsp;</p> -->
            <p
              class="moto-text_normal my-3 container"
              style="text-align: center"
            >
              <span class="moto-color5_5"
                >Take the stress out of travelling to <br />
                and from the airport by booking one of <br />TaxiVIP reliable
                taxis.</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceSection",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("http://fonts.googleapis.com/css?family=Raleway:400,100,200,300,500,600,800,700,900");
/* body{
  font-family: 'Raleway', sans-serif;
} */
.moto-widget-text-content {
  padding: 0 1px;
}
.moto-text_system_13 {
  font-weight: 700;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #ffffff;
  font-size: 66px;
  line-height: 1;
  letter-spacing: -2px;
}
.moto-color1_3 {
  color: #ffffff;
}
.moto-text_system_12 {
  font-weight: 500;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #333333;
  font-size: 30px;
  line-height: 1.4;
  letter-spacing: 0px;
}
.moto-color5_5 {
  color: #ffffff;
}
.moto-text_normal {
  font-weight: 300;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #333333;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0px;
}
.dez-separator {
  display: inline-block;
  height: 3px;
  width: 50px;
  margin-bottom: 10px;
  position: relative;
  /*-moz-transition: all 0.5s;*/
  /*-webkit-transition: all 0.5s;*/
  /*transition: all 0.5s;*/
}
.FadeRight:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 80px;
}
.FadeDown:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 80px;
}
.FadeLeft:hover .dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  width: 80px;
}
.FadeLeft:hover .dez-separator {
  background-color: #ffde20 !important;
}
.FadeDown:hover .dez-separator {
  background-color: #ffde20 !important;
}
.FadeRight:hover .dez-separator {
  background-color: #ffde20 !important;
}
.dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bg-primary {
  background-color: #ffffff !important;
}
.animate1,
.animate2,
.animate3 {
  position: relative;
  top: 0;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.FadeRight:hover .animate1 {
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  color: #ffde20;
}
.FadeDown:hover .animate2 {
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  color: #ffde20;
}
.FadeLeft:hover .animate3 {
  top: -10px;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  color: #ffde20;
}
</style>
